<template>
<div class="container-fluid" >

<modal-spinner v-if="modalSpinner.show==true" @close="setModalSpinner(false)" v-bind:props="modalSpinner"></modal-spinner>  

<confirm-box v-if="cb.show">     
      <template v-slot:header>
        <strong>{{cb.title}}</strong>    
      </template>
      <template v-slot:body1>
        <h4>{{cb.msg1}}</h4>   
      </template>
      <template v-slot:footer>  
        <button @click="cb.show=false" type="button" class="btn btn-secondary">
         
          NO</button>
        <button @click="processModal()" type="button" data-dismiss="modal" class="btn btn-primary">SI</button>
      </template>    
</confirm-box>  



 <div class="card border-success">

  <div class="card-header text-white bg-primary">
    <h4><i class="fas fa-cog mr-2" aria-hidden="true"></i>
    ASSOCIAZIONE PRODOTTO/VARIANTI MARKET 
    <span class="ml-3" style="color:yellow"><strong class="mp">{{market}}</strong></span>
    </h4>
    <small v-if="items.length>0">doppio click modifica riga prodotto</small>
  </div> 

<div  class="card-body">   
<div class="row">
<div v-if="items.length==0" class="col-md-4"> 

  <div  class="card border-info" >
  <div class="card-header  bg-info">
    <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong></div>
  <div class="card-body text-dark">

  <form name="movementSearch" v-on:submit.prevent="submit()">
    
    <label>
      <strong>MARKET</strong>
    </label>
    <select @change="setMP($event)" required class="form-control mb-1" v-model="mpId" >
      <option v-for="(item,index) in marketList" :value="item.MarketPlaceId" :key="index">{{item.MarketPlace}}</option>        
    </select>

    <brand-list v-bind:props="brand" @update="setBrandId"></brand-list>
    <season-select v-bind:props="season"  @update="setSeasonId"></season-select>
    <year-select  v-bind:props="season_year" @update="setYear"></year-select>
    <department-select v-bind:props="department" @update="setDepartmentId"></department-select>
        
    <div class="card-footer bg-transparent border-info"> 

      <alert-box  @close="msg.title=''" v-bind:msg="msg"  ></alert-box>  
      
        <button :disabled="spinner" type="submit"  class="btn btn-primary float-right">
          <i class="far fa-play-circle mr-2"></i>
          ESEGUI
          <span v-if="spinner" class="spinner-border spinner-border-sm ml-3 text-warning" role="status" aria-hidden="true"></span>
        </button>         
    </div>

  </form>
  

  </div>
</div>
</div>


<div v-else class="col">
  <div class="mb-1">
    
  <button  @click="items=[],msg.title=''" type="button"  class="btn btn-secondary mr-4 ml-1 ">
    <i style="color:yellow" class="fas fa-reply mr-2"></i>
    RITORNA A RICERCA PRODOTTI
  </button> 

  
<button v-if="filteredItems.length > 0" @click="setCB()"  type="button"  class="btn btn-dark ml-3 ">
            <i style="color:red" class="fas fa-ban mr-2" aria-hidden="true"></i>
            RIMUOVI PRODOTTI DA MARKET
            <span v-if="spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
</button>  
<button v-if="filteredItems.length > 0" @click="setCB(true)"  type="button"  class="btn btn-info ml-3 ">
            <i style="color: yellow;" class="fas fa-globe mr-2" aria-hidden="true"></i>
            ASSOCIA PRODOTTI A MARKET
            <span v-if="spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
</button>  
<!--
<button  v-if="filteredItems.length > 0" type="button" @click="refresh++"  class="btn btn-success ml-3 " data-toggle="modal" data-target="#modal_MPProductDiscount">
            <i class="fas fa-calculator mr-2" aria-hidden="true"></i>
            APPLICA SCONTO
            
</button>  
-->



</div>  


<div class="row">
<div class="col">

<div class="table-wrapper-scroll-y my-custom-scrollbar">
<table class="table table-hover table-sm table-bordered table-striped mb-0">
    <thead >
      <tr class="table-primary">
        <th scope="col">#</th>
        <th scope="col"></th>
        
        <th scope="col">
          <i  class="fas fa-globe " aria-hidden="true"></i>
        </th>
        <th scope="col">ID PRODOTTO</th>
        <th scope="col">BRAND</th>
        <th scope="col">LINEA</th>
        <th scope="col">CODICE</th>                
       
        <th scope="col">CATEGORIA</th>
        <th scope="col">DESCRIZIONE</th>
        
        <th scope="col">REPARTO</th>
       
        <th class="text-right" scope="col">LISTINO</th>              
      </tr>
    </thead>
    <tbody>
      
      <tr  class="pointer" v-on:dblclick="setProductCombinations(index)"  v-for="(item, index) in filteredItems" :key="index">
        <td>{{index+1}}</td>
        <td> <i @click="setImg(item.img)" class="fas fa-camera" aria-hidden="true"></i></td>
        <td> <span :class="{dotRed:item.mp_count == 0}"></span></td>
        
        <td>{{item.productId}}</td>

        <td class="text-nowrap">{{item.brand}}</td>
        <td class="text-nowrap">{{item.line}}</td>
        <td class="text-nowrap">{{item.sku}}
        
        
          <div v-if="isOpen[index]==true">
            <combinations @update="setData" v-bind:product="item" @close="closeModal()"></combinations>          
          </div>
        
        
        
        </td>        
        
        <td>{{item.category}}</td>
        <td class="text-nowrap">{{item.description}}</td>
        
        <td>{{item.department}}</td>
        <!--<td class="text-nowrap">{{item.season}}-{{item.season_year}} </td>-->      
        <td class="text-right">{{fmt1(item.priceList)}}</td>
              
      </tr> 
      
      
    </tbody>
 
  </table>
  
</div>

<div v-if="progress>0" class="progress">
    <div class="progress-bar progress-bar-striped" role="progressbar"  :style="{'width':getProgress}">
      {{ progress }}%
    </div>
</div>
  

<label for="cerca"><strong>
  <i  class="fas fa-filter mr-2" aria-hidden="true"></i>
    Filtra</strong></label>
<input class="form-control mb-3" type="text" name="query" v-model="filterKey">

<alert-box  @close="msg.title=''" v-bind:msg="msg"  ></alert-box>




</div>


</div>
</div>

<img-zoom v-if="img" @close="closeImg()" v-bind:img='img'></img-zoom>

</div>
</div>
</div>
</div>

</template>
<script>
import api               from "@/api";
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';


import brandList         from '@/components/common/CompanyBrandSelect_1.vue'
import seasonSelect      from '@/components/common/SeasonSelect_1.vue'
import yearSelect        from '@/components/common/YearSelect_1.vue'
import combinations      from '@/components/admin/ProductCombinations.vue'
import confirmBox        from '@/components/common/ConfirmBox.vue'
import departmentSelect  from '@/components/common/DepartmentSelect_1.vue';


import imgZoom           from '@/components/common/ProductImg.vue'

import modalSpinner      from '@/components/common/ModalSpinner.vue'
import fmt               from '@/components/mixins/fmt.js'
//import modalDiscount     from '@/components/admin/ModalDiscount.vue'

export default {
  components: {alertBox,seasonSelect,yearSelect,imgZoom,brandList,combinations,confirmBox,departmentSelect,modalSpinner},
  mixins:[fmt],
  data() {
    return {

      modalSpinner    : {spinner:false,show:false},
      market          : '',
      index           : 0,
      mpId            : 0,
      marketList      : [], 
      isOpen          : [],
     
      filterKey       : '',
     
      brand           :
      {
        Id            : '',
        required      : true,
        all           : true

      },
      season          : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        type          : true


      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true

      },
      department      : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false,
       
      },

      spinner         : false,
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
    
      items           : [], 
      img             : '',
            
      progress        : 0,
      cb              : {title : '',msg1 : '',show:false,option:false},
      refresh         : 0
          
    };
  },

  computed :{
    ...mapGetters(['company']),
    
   getProgress()
    {
      let p = this.progress
      return p + "%";
    },

   
    filteredItems : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },

     
    
  
  },
  
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() 
  {

    this.getMarketPlaceList()
    
  },
  methods: 
  {
    setModalSpinner(show)
    {
      

      this.modalSpinner.show = show
      
    },
    setCB(option)
    {
      if(option)
      {
        this.cb.option = true
        this.cb.title = 'ASSOCIAZIONE PRODOTTI A MARKET ' + this.market
        this.cb.msg1  = 'SI DESIDERA ASSOCIARE I PRODOTTI ?'
      }
      else
      {

        this.cb.option = false
        this.cb.title = 'RIMOZIONE PRODOTTI DA MARKET ' + this.market
        this.cb.msg1  = 'SI DESIDERA RIMUOVERE I PRODOTTI ?'
      }


      this.cb.show  = true
    },
    processModal()
    {  
      if(this.cb.option) 
      {
        this.joinProductsToMarket()
      }
      else
      {
       this.deleteProductsToMarket()
      } 
    },  
    setMP(e)
    {
      this.market = e.target.options[e.target.options.selectedIndex].text      
    },
    setData(arr,total)
    {     
      this.filteredItems[this.index].data = JSON.stringify(arr)
      let i = 0
      this.filteredItems.forEach(item=>
      {
                 
        if(i == this.index)
        {
          item.mp_count = total
        }
        i++
      })
    },
    closeModal()
    {
       $('#productCombinations').modal('hide')
       this.isOpen=[]
    },
    setProductCombinations(index)
    {
      this.index         = index
      this.isOpen        = []
      this.isOpen[index] = true
      
      this.$nextTick()
      .then(function () {

        $('#productCombinations').modal('show')
      
      })
      
    },
    setBrandId(brandId)
    {
      this.brand.Id = brandId

      
    },
    async getMarketPlaceList()
    {
      var sp    = {'sp':'spCompanyMarketPlace'}
      var data  = {'companyId' : this.company.Id}
     
      var json  = Object.assign(data, sp);
      
      await api.post(json).then(res => {
        if(res.status==200)
          {
            this.marketList =  res.data.recordsets[0]         
          }
          else if(res.status==500)
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type = 1

          } 
          else
          {
            this.msg.title = 'ATTENZIONE '                       
            this.msg.body = res
            this.msg.type = 1                
          } 
      }).catch(err => 
      {
      
        this.msg.title = 'ATTENZIONE '
        this.msg.body = err.message
        this.msg.type = 1           
      }).finally(() => {
        //this.spinner = false
      });

    },
    
    scrollToElement(options) {
      const el = this.$el.getElementsByClassName('index-0')[0];
      
      if (el) {
        el.scrollIntoView(options);
      }
    },
    setAltImg(event) 
    { 
        event.target.src = require("@/assets/no_img.jpg")
    },         
 
    setImg(img)
    {
        this.img = img
    },
    closeImg()
    {
        this.img = ''
    },
    

    

  
    setSeasonId(seasonId)
    {   
        
        this.season.Id = seasonId
    },  
    setYear(year)
    {
        this.season_year.year = year
    },
       setDepartmentId(departmentId)
    {
      this.department.Id = departmentId
    },
    submit() 
    {
      this.getData()
      
    },  
    
    
    
    async getData() {
      
     
      this.items  = []
        
      this.msg.title = ''
      const sp = {'sp' : 'spProductsCombinationsToMarket'}

      

      const data  = 
      {
        'companyId'   : this.company.Id,
        'brand'       : this.brand.Id == 'TUTTI I BRAND' ? '%':this.brand.Id,
        'seasonId'    : this.season.Id,
        'departmentId': this.department.Id,
        'year'        : this.season_year.year,
        'mpId'        : this.mpId
      }
      
      const json  = Object.assign(data, sp)      
      this.spinner = true

      await api.post(json).then(async res => {
         
          if(res.status==200)
            {
              
              
              this.items = res.data.recordsets[0]  
              
              

                
              if(this.items.length==0)
              {
               
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }

            }
            else if (res.status==500)
            {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {

           
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
                        

          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
        

      }).finally(() => {
          this.spinner = false
        });
      

    },

    async deleteProductsToMarket() {
    
      this.cb.show   = false

      this.modalSpinner.show    = true
      this.modalSpinner.spinner = true
      
      this.modalSpinner.title   = 'Rimozione prodotti in corso ...'

      let arr        = []
      this.msg.title = ''
      const sp         = {'sp' : 'spDeleteProductsToMarket'}
      this.filteredItems.forEach(item => {

          arr.push({'productId':item.productId})

      })
      const data  = {
        'data'        : arr,
        'mpId'        : this.mpId
      }
      
      var json  = Object.assign(data, sp)      
   
      //this.spinner = true

      await api.post(json).then(async res => {
         
          if(res.status==200)
            {
              
              this.filteredItems.forEach(item=>{
                item.mp_count = 0
              })

              this.modalSpinner.show    = true
              this.modalSpinner.spinner = false

      
              this.modalSpinner.title   = 'RIMOZIONE EFFETTUATA.'

              /*
              this.msg.title = 'RIMOZIONE EFFETTUATA.'
              this.msg.body  = ''
              this.msg.type  = 0
              */

              
             

            }
            else if (res.status==500)
            {
              
              this.modalSpinner.show    = true
              this.modalSpinner.spinner = false

      
              this.modalSpinner.title   = res.data

              /*
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              */
              
            }
          
          else
          {

            this.modalSpinner.show    = true
            this.modalSpinner.spinner = false
            this.modalSpinner.title   = res
            /*
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
            */
                        

          }
      }).catch(err=>{
        
            this.modalSpinner.show    = true
            this.modalSpinner.spinner = false
            this.modalSpinner.title   = err.message
            /*
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
            */
        

      }).finally(() => {
          //this.spinner = false
        });
      

    },

     async joinProductsToMarket() {
      
      this.cb.show   = false
      this.modalSpinner.show    = true
      this.modalSpinner.spinner = true

      this.modalSpinner.title   = 'Associazione prodotti in corso ...'
          
      let arr        = []
      this.msg.title = ''
      const sp       = {'sp' : 'spJoinProductsToMarket'}
      this.filteredItems.forEach(item => {

        arr.push({'productId':item.productId})

      })

      let data  = {
        'data'        : arr,
        'mpId'        : this.mpId
      }
      
      const json  = Object.assign(data, sp)      
   
      //this.spinner = true

      await api.post(json).then(async res => {
         
          if(res.status==200)
            {
              
              this.filteredItems.forEach(item=>{
                item.mp_count = 1
              })


              this.modalSpinner.show    = true
              this.modalSpinner.spinner = false
              this.modalSpinner.title   = 'ASSOCIAZIONE EFFETTUATA.'
              
              /*
              this.msg.title = 'ASSOCIAZIONE EFFETTUATA.'
              this.msg.body  = ''
              this.msg.type  = 0
              */

              
             

            }
            else if (res.status==500)
            {
              
              this.modalSpinner.show    = true
              this.modalSpinner.spinner = false
              this.modalSpinner.title   = res.data

              /*
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              */
              
            }
          
          else
          {

            this.modalSpinner.show    = true
            this.modalSpinner.spinner = false
            this.modalSpinner.title   = res
            /*
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
            */
                        

          }
      }).catch(err=>{
        
            
            this.modalSpinner.show    = true
            this.modalSpinner.spinner = false
            this.modalSpinner.title   = err.message
            /*
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
            */
        

      }).finally(() => {
          //this.spinner = false
        });
      

    },


  }

}
</script>
<style scoped>

.my-custom-scrollbar {
  position   : relative;
  height     : 600px;
  overflow   : auto;
}
.brandList {
  position  : relative;
  height    : 400px;
  overflow  : auto;
}
.brandItems {
  position  : relative;
  height    : 500px;
  overflow  : auto;
}
.pointer:hover
{
  _background-color: white;
  
  cursor: pointer;
}


.products tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : #66CCFF; 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }


.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }



 .table tfoot  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 24px;
    background   : whitesmoke;
    color        : darkgreen;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 } 



.table-wrapper-scroll-y {
display: block;
}




h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}


div.catalog {
 
  height: 500px;
  _width: 200px;
  overflow-y: scroll;
}
.dotRed
{
  height: 15px;
  width: 15px;
  
  border-radius: 50%;
  display: inline-block;
  background-color: red;
}
.mp 
{
  font-family  : 'Roboto Condensed' !important;
  font-size    : 28px !important;
}

</style>